/*
 * Copyright (c) 2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 *
 */

'use strict';

var _interopRequire = require('babel-runtime/helpers/interop-require')['default'];

Object.defineProperty(exports, '__esModule', {
  value: true
});

var _componentDocblockHandler = require('./componentDocblockHandler');

exports.componentDocblockHandler = _interopRequire(_componentDocblockHandler);

var _defaultPropsHandler = require('./defaultPropsHandler');

exports.defaultPropsHandler = _interopRequire(_defaultPropsHandler);

var _propTypeHandler = require('./propTypeHandler');

exports.propTypeHandler = _interopRequire(_propTypeHandler);

var _propTypeCompositionHandler = require('./propTypeCompositionHandler');

exports.propTypeCompositionHandler = _interopRequire(_propTypeCompositionHandler);

var _propDocBlockHandler = require('./propDocBlockHandler');

exports.propDocBlockHandler = _interopRequire(_propDocBlockHandler);

var _displayNameHandler = require('./displayNameHandler');

exports.displayNameHandler = _interopRequire(_displayNameHandler);


/*****************
 ** WEBPACK FOOTER
 ** ./~/react-docgen/dist/handlers/index.js
 ** module id = 628
 ** module chunks = 0
 **/